/**
 *
 * ModalCreateUser
 *
 */

import React from "react"
import PropTypes from "prop-types"
import "./index.less"
import Modal from "antd/lib/modal/Modal"
import { requestUpgradeApi } from "../../services/requestUpgrade"

/* eslint-disable react/prefer-stateless-function */
class ModalContact extends React.Component {
  state = {}

  componentDidUpdate = () => {}

  async handleOk() {
    await requestUpgradeApi()
    await this.props.handleOk()
  }

  render() {
    const {
      isModalVisible,
      handleCancel,
      titleModal,
      contentModal,
      imgExampleModal,
    } = this.props
    return (
      <Modal
        className="modal-promo"
        title={imgExampleModal}
        visible={isModalVisible}
        onOk={() => this.handleOk()}
        onCancel={handleCancel}
        closable={false}
        width="607px"
        cancelText="Cerrar"
        okText="Contáctanos">
        <div className="container_promo">
          <div className="title_promo">{titleModal}</div>
          <div className="content_promo">{contentModal}</div>
        </div>
      </Modal>
    )
  }
}

ModalContact.propTypes = {
  isModalVisibleL: PropTypes.bool,
  handleCancel: PropTypes.func,
  titleModal: PropTypes.string,
  contentModal: PropTypes.object,
  imgExampleModal: PropTypes.object,
}

export default ModalContact
